import { isBrowser } from 'lib/BrowserDetection';
import MobileDetection from 'lib/MobileDetection';

/**
 * Encodes Fast Channel iframe URLs to JSON so that we can pass mobile app xumo
 * parameters to local
 * @see https://nbcnewsdigital.atlassian.net/wiki/spaces/CNBCAND/pages/4796186725/Privacy+and+Programmatic+Metadata+in+WebView
 */
export const encodeWindowUrlToJson = () => {
  try {
    if (window.location.search) {
      if (window.location.search !== '?chromeless=true') {
        const xumoUrlParams = JSON.stringify(window.location.search);
        const xumoUrl = xumoUrlParams.replace('?', '').replace('&chromeless=true', '');
        const encodedString = encodeURIComponent(xumoUrl);
        return encodedString;
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error encoding url to JSON', error);
  }
  return false;
};

/**
 * Encodes string to JSON
 * @param {string} params - the string params we're looking to encode.
 */
export const encodeStringToJson = (params) => {
  try {
    const jsonParams = JSON.stringify(params);
    const encodedString = encodeURIComponent(jsonParams);
    return encodedString;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error encoding string to JSON', error);
  }
  return false;
};


const commonXumoParam = { afid: '137704898' };

export const xumoDefaultParams = {
  web: {
    csid: 'nbcnews_alldevice_allos_web_livelinear_virtualchannel',
    sfid: '7006068',
    fwnielsenappid: '',
    fwappbundle: '',
  },
  android: {
    csid: 'nbcnews_mobile_android_app_livelinear_virtualchannel',
    sfid: '7089397',
    fwnielsenappid: 'PF5ECB73F-BE6D-4031-8689-9EDD92779E54',
    fwappbundle: 'com.zumobi.msnbc',
  },
  ios: {
    csid: 'nbcnews_mobile_ios_app_livelinear_virtualchannel',
    afid: '137704898',
    sfid: '6976775',
    fwnielsenappid: 'PF5ECB73F-BE6D-4031-8689-9EDD92779E54',
    fwappbundle: '319740707',
  },
};

/**
 * Detects platform
 * @param {string} ua - the string user agent we're looking to detect a platform.
 */
export const detectPlatform = (ua = '') => {
  const uaLower = ua.toLowerCase();
  if (/android/i.test(uaLower) || MobileDetection.Android()) return 'android';
  if (/iphone|ipad|ipod/i.test(uaLower) || MobileDetection.iOS()) return 'ios';
  return 'web';
};

/**
 * Returns current url href
 * @param {string} referer - the current string url
 */
const resolveSitePage = (referer = '') => {
  if (isBrowser() && typeof window !== 'undefined' && window.location?.href) {
    return window.location.href;
  }
  return referer || '';
};

/**
 * Builds the encoded xumo params
 * @param {string} ua - the string user agent
 * @param {string} referer - the string referrer url
 */
export const buildEncodedXumoParams = (ua, referer) => {
  const platform = detectPlatform(ua || (isBrowser() ? navigator.userAgent : ''));
  const sitePage = resolveSitePage(referer);
  const params = {
    ...commonXumoParam,
    ...xumoDefaultParams[platform],
    fwsitepage: sitePage,
  };

  const queryString = Object.entries(params)
    .map(([k, v]) => `${k}=${v}`)
    .join('&');
  return encodeURIComponent(JSON.stringify(`&${queryString}`));
};

export const encodedString = encodeWindowUrlToJson();

export const encodedXumoDefaultParams = buildEncodedXumoParams();
